/**
 * injects the google map api script to the index.html,
 * and set the app to a ready state once the script has successfully
 * loaded
 */
export default function initializeGoogle(callback) {
  const apiKey = process.env.GOOGLE_API_KEY;
  const existingScript = document.getElementById('googleMaps');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=3.exp&libraries=places`;
    script.id = 'googleMaps';
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) {
        callback();
      }
    };
  } else {
    if (callback) {
      callback();
    }
  }
}
